<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t('school.academic.setup.program.subject.core_subjects.core_subject')
        }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'school.academic.setup.program.subject.core_subjects.core_subject'
            ),
            active: true
          }
        ]"
      />
    </div>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">
              {{
                $t(
                  'school.academic.setup.program.subject.core_subjects.add_new'
                )
              }}
            </ts-button>
            <ts-input
              v-model="search"
              :placeholder="
                $t('school.academic.setup.program.subject.core_subjects.search')
              "
              style="width: 300px;"
            />
          </div>
        </ts-card-wrapper>
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td>{{ record.subject_name_foreign }}</td>
            <td>{{ record.subject_name_native }}</td>
            <td>{{ record.subject_code }}</td>
            <td>
              {{
                record.sub_program ? record.sub_program.acps_name_foreign : ''
              }}
            </td>
            <td>{{ record.program ? record.program.acp_name_foreign : '' }}</td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="
                  $t('school.academic.setup.program.subject.core_subjects.edit')
                "
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="
                  $t(
                    'school.academic.setup.program.subject.core_subjects.delete'
                  )
                "
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table-expand :componentLists="prop.record.component_list" />
          </div>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData">
          </ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'
import TableExpand from './table-expand.vue'

export default {
  name: 'subject-core',
  components: { FormComponent, TableExpand },
  props: ['programs', 'subPrograms', 'subjects'],
  data () {
    return {
      loading: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('subjectCore', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.subjectCore.search
      },
      set (newValue) {
        this.$store.commit('subjectCore/SET_SEARCH', newValue)
        this.$store.commit('subjectCore/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.subject_(en)'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.subject_(kh)'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.subject_code'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.sub_program'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.main_program'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.actions'
          ),
          style: 'text-align:center; width: 1px;'
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('subjectCore/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit (record) {
      this.showForm(record)
    },
    async destroy (record) {
      if (
        await this.$confirmModal.danger(
          this.$t(
            'school.academic.setup.program.subject.core_subjects.are_you_sure_to_delete'
          )
        )
      ) {
        record._deleting = true
        this.$store
          .dispatch('subjectCore/destroy', record.subject_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm (editData) {
      this.$modal.show(
        FormComponent,
        {
          programs: this.programs,
          subPrograms: this.subPrograms,
          subjects: this.subjects,
          editData: editData
        },
        {
          height: 'auto',
          scrollable: true,
          clickToClose: false,
          width: '60%',
          draggable: '.form-header'
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'subject-core-create') {
      this.$store.commit('subjectCore/RESET_STATE')
    }
    next()
  }
}
</script>
